import { faChevronUp, faChevronDown } from "@jewlr/pro-regular-svg-icons"
import { Box, FontAwesomeIcon, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useState } from "react"

import AffirmDetail from "./affirm-detail"
import {
  Container,
  PlanGirlImage,
  PlanImage,
  PlanTitle,
  PlanDesc,
} from "./component"

const Affirm = ({ paymentPrices }) => {
  const [hideDetail, setHideDetail] = useState(true)

  return (
    <Container mb={4}>
      <Box maxWidth={{ desktop: "344px" }} mx="auto">
        <PlanTitle>Sparkle Now, Pay Later</PlanTitle>
        <PlanImage
          alt="Jewlr Affirm"
          ratio="294 / 117"
          srcSet={`${require("images/info/payment_plans/affirm-jewlr-payments.png")} 294w, ${require("images/info/payment_plans/affirm-jewlr-payments-2x.png")} 586w`}
        />
        <PlanDesc>
          With easy and manageable payment options, you choose the plan that
          works best for you: Split Pay or Simple Financing.
        </PlanDesc>
        <PlanGirlImage
          alt="Affirm Girl"
          src={require("images/info/payment_plans/affirm-girl-x2.jpg")}
        />
        <MediaBox
          color="link"
          lessThan="desktop"
          onClick={() => setHideDetail(!hideDetail)}
          pb={hideDetail ? 0 : "22px"}
        >
          <span style={{ textDecoration: "underline" }}>How it works</span>
          <FontAwesomeIcon
            color="link"
            icon={hideDetail ? faChevronDown : faChevronUp}
            style={{ marginLeft: "4px", verticalAlign: "sub" }}
          />
        </MediaBox>

        <MediaBox {...(!hideDetail && { lessThan: "desktop" })}>
          <AffirmDetail paymentPrices={paymentPrices} />
        </MediaBox>
      </Box>
    </Container>
  )
}

Affirm.propTypes = {
  paymentPrices: PropTypes.object,
}

export default Affirm
